import { Events } from '../../utils/servicesEvents'
import { Formatter } from './formatter'
import { AppDataRepo } from './repo'
import { AppData } from './appData'
import { Commons } from '@/utils/commons'

import { getProducts } from './networks/products/getProducts'
import { getOrders } from './networks/orders/getOrders'
import { getCustomers } from './networks/customers/getCustomers'
import { createProduct } from './networks/products/createProduct'
import { updateProduct } from './networks/products/updateProduct'
import { getPayments } from './networks/payments/getPayments'
import { getKycData } from './networks/kyc/getKycData'
import { saveAccountValidationKycData } from './networks/kyc/saveAccountValidationKycData'
import { deleteCustomer } from './networks/customers/deleteCustomer'
import { searchPayments } from './networks/payments/searchPayments'
import { getCategories } from './networks/products/getCategories'
import { sendHelpMessage } from './networks/chat/sendHelpMessage'
import { saveStorePreferences } from './networks/store/saveStorePreferences'
import { getBalance } from './networks/stats/getBalance'
import { getStoreData } from './networks/store/getStoreData'
import { publishProduct } from './networks/products/publishProduct'
import { unpublishProduct } from './networks/products/unpublishProduct'
import { deleteProduct } from './networks/products/deleteProduct'
import { launchSubscriptionPayment } from './networks/proSubscription/launchSubscriptionPayment'
import { updateOrderStatus } from './networks/orders/updateOrderStatus'
import { getSubscription } from './networks/proSubscription/getSubscription'
import { getStoreDetails } from './networks/store/getStoreDetails'
import { resolvePhoneNumber } from '../transaction/networks/resolvePhoneNumber'
import { getAppInfos } from './networks/appInfos/getAppInfos'
import { getStats } from './networks/stats/getStats'
import { createDeal } from './networks/deals/createDeal'
import { updateDeal } from './networks/deals/updateDeal'
import { deleteDeal } from './networks/deals/deleteDeal'
import { getDeals } from './networks/deals/getDeals'
import { getRiders } from './networks/riders/getRiders'
import { createRider } from './networks/riders/createRider'
import { deleteRider } from './networks/riders/deleteRider'
import { getWithdrawalAccounts } from './networks/withdrawal/getWithdrawalAccounts'
import { createWithdrawalAccount } from './networks/withdrawal/createWithdrawalAccount'
import { deleteWithdrawalAccount } from './networks/withdrawal/deleteWithdrawalAccount'
import { getWithdrawals } from './networks/withdrawal/getWithdrawals'
import { createWithdrawal } from './networks/withdrawal/createWithdrawal'
import { getPlatformAccessSubscription } from './networks/platformAccessSubscription/getPlatformAccessSubscription'
import { launchPlatformAccessSubscriptionPayment } from './networks/platformAccessSubscription/launchPlatformAccessSubscriptionPayment'
import { createManyDeals } from './networks/deals/createManyDeals'
import { getChargebacks } from './networks/payments/getChargebacks'
import { launchPromotionRequest } from './networks/products/launchPromotionRequest'
import { updateProductsCurrency } from './networks/products/updateProductsCurrency'
import { getDeliveryLocations } from './networks/location/getDeliveryLocations'
import { getCountryCitites } from './networks/location/getCountryCitites'
import { deleteDeliveryLocation } from './networks/location/deleteDeliveryLocation'
import { createManyDeliveryLocations } from './networks/location/createManyDeliveryLocations'
import { updateDeliveryLocation } from './networks/location/updateDeliveryLocation'
import { getRates } from './networks/appInfos/getRates'
import { getDomainNameInstallation } from './networks/domainName/getDomainNameInstallation'
import { installDomainName } from './networks/domainName/installDomainName'

class AppDataController {
  static async downloadUserData() {
    // const userReference = await self.servicesVars.getUserReference()
    // if (!userReference) return
  }

  static async downloadRequirements() {
    getStoreData('store_data_downloaded', 'failed_to_download_app_data')
  }

  static async checkHasPlatformAccess() {
    const db = await AppDataRepo.getDb()
    let data = await db.get('platformAccessSubscription')
    let subscription = await db.get('subscription')
    if (!data.metaData.isActive && !subscription.metaData.isActive) {
      console.log('platform acces required')
      Events.dispatchEvent('platform_access_required')
      return false
    }
    return true
  }

  static async downloadAllData() {
    getKycData('app_data_downloaded', 'failed_to_download_app_data')
    getBalance('app_data_downloaded', 'failed_to_download_app_data')
    getStats('app_data_downloaded', 'failed_to_download_app_data')
    getRates('app_data_downloaded', 'failed_to_download_app_data')
    getStoreData('app_data_downloaded', 'failed_to_download_app_data')
    getKycData('app_data_downloaded', 'failed_to_download_app_data')
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
    // getOrders('app_data_downloaded', 'failed_to_download_app_data')
    getCustomers('app_data_downloaded', 'failed_to_download_app_data')
    getRiders('app_data_downloaded', 'failed_to_download_app_data')
    getDeliveryLocations('app_data_downloaded', 'failed_to_download_app_data')
    // getPayments('app_data_downloaded', 'failed_to_download_app_data')
    getCategories('app_data_downloaded', 'failed_to_download_app_data')
    getSubscription('app_data_downloaded', 'failed_to_download_app_data')
    getPlatformAccessSubscription(
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
    getAppInfos('app_data_downloaded', 'failed_to_download_app_data')
    getWithdrawalAccounts(
      'many_app_data_downloaded',
      'failed_to_download_app_data',
    )
    // getWithdrawals('many_app_data_downloaded', 'failed_to_download_app_data')
  }

  static async initListeners() {
    listendDataCleaningRequest()
    listenAppDataRequest()
    listenAppDataDownloaded()
    listenAppDataSet()
  }

  static async getStoreData() {
    const db = await AppDataRepo.getDb()
    let data = await db.get('storeData')
    return data
  }
}

function listendDataCleaningRequest() {
  Events.handleEvent('clean_all_data_requested', async () => {
    const db = await AppDataRepo.getDb()
    await db.clean()
    Events.dispatchEvent('app_data_updated')
  })
}

function listenAppDataDownloaded() {
  Events.handleEvent('store_data_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
    AppDataController.downloadAllData()
  })

  Events.handleEvent('app_data_downloaded', async ({ data }) => {
    const db = await AppDataRepo.getDb()
    await db.save(data)
    Events.dispatchEvent('app_data_updated')
  })

  Events.handleEvent('many_app_data_downloaded', async ({ data }) => {
    if (!data || !Array.isArray(data)) return
    const db = await AppDataRepo.getDb()
    await Promise.all(
      data.map(async singleData => {
        if (!singleData) return
        await db.save(data)
      }),
    )
    Events.dispatchEvent('app_data_updated')
  })

  Events.handleEvent('app_data_updated', async ({ data }) => {
    const userReference = await self.servicesVars.getUserReference()
    if (!userReference) return
    const db = await AppDataRepo.getDb()
    const accountLocked = await db.get('accountLocked')
    if (!accountLocked) return
    if (accountLocked && accountLocked?.metaData?.isLocked) {
      Events.dispatchEvent('toast_notification', {
        title: 'Votre compte est bloqué',
        body: "Votre compte a été bloqué. Contactez nous depuis notre site web kingrecharge.bet si vous pensez qu'ils s'agit d'une erreur",
      })
      Events.dispatchEvent('logout_requested')
    }
  })
}

function listenAppDataRequest() {
  const appDataKeys = [
    'appVersionData',
    'appInfo',
    'contacts',
    'kycData',
    'categories',
    'walletInfo',
    'subscription',
    'platformAccessSubscription',
    'stats',
    'deliveryLocations',
    'withdrawalAccountsBank',
    'withdrawalAccountsMomo',
    'rates',
  ]
  appDataKeys.forEach(key => {
    Events.handleEvent(`request:${key}`, async ({ responseId }) => {
      const db = await AppDataRepo.getDb()
      const data = await db.get(key)
      Events.dispatchEvent(responseId, data)
    })
  })

  Events.handleEvent('request:locationData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('locationData')
    if (!data) {
      const response = await downloadLocationData(
        'app_data_downloaded',
        'failed_to_download_app_data',
      )
      if (response.success) data = response.data
    }
    Events.dispatchEvent(responseId, data)
  })

  Events.handleEvent(
    'request:storeDetails',
    async ({ responseId, storeId }) => {
      const res = await getStoreDetails(storeId)
      let result = {}
      if (res.statusCode === 200 && res.data) result = res.data
      Events.dispatchEvent(responseId, result)
    },
  )

  Events.handleEvent(
    'request:domainNameInstallation',
    async ({ responseId, domain }) => {
      const res = await getDomainNameInstallation(domain)
      Events.dispatchEvent(responseId, res)
    },
  )

  Events.handleEvent(
    'request:installDomainName',
    async ({ responseId, domain }) => {
      const res = await installDomainName(domain)
      Events.dispatchEvent(responseId, res)
    },
  )

  Events.handleEvent('request:products', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('products')
    Events.dispatchEvent(responseId, data?.metaData?.products || null)
  })

  Events.handleEvent('request:topProducts', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('products')
    const products = data?.metaData?.products || []
    const topProducts = products.filter(product => product.isTop)
    Events.dispatchEvent(responseId, topProducts)
  })

  Events.handleEvent('request:topProducts', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('topProducts')
    Events.dispatchEvent(responseId, data?.metaData?.products || [])
  })

  Events.handleEvent('request:deals', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('deals')
    Events.dispatchEvent(responseId, data?.metaData?.deals || [])
  })

  Events.handleEvent(
    'request:promotionBookingDetails',
    async ({ responseId }) => {
      await new Promise(r => setTimeout(r, 2500))
      Events.dispatchEvent(responseId, {
        statusCode: 200,
        cost: 500,
        durationInDay: 5,
        periodIsAvailable: true,
      })
    },
  )

  Events.handleEvent(
    'request:orders',
    async ({ responseId, limit, page, status }) => {
      const res = await getOrders({ limit, page, status })
      Events.dispatchEvent(responseId, res.data || null)
    },
  )

  Events.handleEvent('request:customers', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('customers')
    Events.dispatchEvent(responseId, data?.metaData?.customers || null)
  })

  Events.handleEvent('request:riders', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('riders')

    Events.dispatchEvent(responseId, data?.metaData?.riders || [])
  })

  Events.handleEvent(
    'request:payments',
    async ({ responseId, limit, page }) => {
      const res = await getPayments({ limit, page })
      Events.dispatchEvent(responseId, res.data || null)
    },
  )

  Events.handleEvent(
    'request:withdrawalsByBank',
    async ({ responseId, page, limit }) => {
      const res = await getWithdrawals({ page, limit, type: 'bank' })
      if (res.statusCode !== 200) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, res.data)
    },
  )

  Events.handleEvent(
    'request:withdrawalsByMomo',
    async ({ responseId, page, limit }) => {
      const res = await getWithdrawals({ page, limit, type: 'mobileMoney' })
      if (res.statusCode !== 200) {
        Events.dispatchEvent(responseId, null)
        return
      }
      Events.dispatchEvent(responseId, res.data)
    },
  )

  Events.handleEvent('request:storeData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('storeData')

    Events.dispatchEvent(responseId, data || null)
  })

  Events.handleEvent('request:withdrawalAccounts', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('storeData')
    const withdrawalAccounts = data?.metaData?.withdrawalAccounts || []

    Events.dispatchEvent(responseId, withdrawalAccounts)
  })

  Events.handleEvent(
    'request:searchTransaction',
    async ({ responseId, searchText, page, limit }) => {
      const response = await searchPayments({ searchText, page, limit })
      Events.dispatchEvent(responseId, response.data || null)
    },
  )

  Events.handleEvent(
    'request:chargebacks',
    async ({ responseId, page, limit }) => {
      const response = await getChargebacks({ page, limit })
      Events.dispatchEvent(responseId, response.data || null)
    },
  )

  Events.handleEvent('request:checkoutData', async ({ responseId }) => {
    const db = await AppDataRepo.getDb()
    let data = await db.get('checkoutData')
    if (!data) {
      data = new AppData().setContent('checkoutData').setMetaData({
        totalAmount: 0,
        totalDichesAmount: 0,
        deliveryAmount: 0,
        fees: 0,
        orderedDiches: [],
      })
    }
    Events.dispatchEvent(responseId, Commons.changeToJson(data))
  })

  Events.handleEvent(
    'request:countryCities',
    async ({ responseId, countryCode }) => {
      const res = await getCountryCitites({ countryCode })
      if (res.statusCode == 200) {
        Events.dispatchEvent(responseId, res.data)
        return
      }
      Events.dispatchEvent(responseId, null)
    },
  )

  Events.handleEvent('new_checkout_data_available', async data => {
    const db = await AppDataRepo.getDb()
    const dataToSave = new AppData()
      .setContent('checkoutData')
      .setMetaData(data)
    await db.save(dataToSave)
    Events.dispatchEvent('checkout_updated')
  })

  Events.handleEvent('request:resolvePhoneNumber', async data => {
    const { responseId } = data
    resolvePhoneNumber(data, responseId, responseId)
  })
}

function listenAppDataSet() {
  Events.handleEvent('new_product_ready_to_be_added', data => {
    createProduct(data, 'product_created', 'failed_to_create_product')
  })
  Events.handleEvent('product_created', () => {
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('product_ready_to_be_updated', data => {
    updateProduct(data, 'product_updated', 'failed_to_update_product')
  })
  Events.handleEvent('product_publish_requested', async ({ id }) => {
    const canContinue = await AppDataController.checkHasPlatformAccess()
    if (!canContinue) return
    publishProduct(id, 'product_published', 'failed_to_publish_product')
  })
  Events.handleEvent('product_unpublish_requested', ({ id }) => {
    unpublishProduct(id, 'product_unpublished', 'failed_to_unpublish_product')
  })
  Events.handleEvent('product_deletion_requested', ({ id }) => {
    deleteProduct(id, 'product_deleted', 'failed_to_delete_product')
  })
  Events.handleEvent('product_updated', () => {
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('product_published', () => {
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('product_unpublished', () => {
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('product_deleted', () => {
    getProducts('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_deal_ready_to_be_added', async data => {
    const canContinue = await AppDataController.checkHasPlatformAccess()
    if (!canContinue) return
    createDeal(data, 'deal_created', 'failed_to_create_deal')
  })
  Events.handleEvent('many_deals_ready_to_be_added', async data => {
    console.log('sfds')
    const canContinue = await AppDataController.checkHasPlatformAccess()
    if (!canContinue) return
    createManyDeals(data, 'deal_created', 'failed_to_create_deal')
  })
  Events.handleEvent('deal_ready_to_be_updated', async data => {
    const canContinue = await AppDataController.checkHasPlatformAccess()
    if (!canContinue) return
    updateDeal(data, 'deal_updated', 'failed_to_update_deal')
  })
  Events.handleEvent('deal_deletion_requested', ({ id }) => {
    deleteDeal(id, 'deal_deleted', 'failed_to_delete_deal')
  })
  Events.handleEvent('deal_created', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('deal_updated', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('deal_deleted', () => {
    getDeals('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_rider_ready_to_be_added', data => {
    createRider(data, 'rider_created', 'failed_to_create_rider')
  })
  Events.handleEvent('rider_deletion_requested', ({ id }) => {
    deleteRider(id, 'rider_deleted', 'failed_to_delete_rider')
  })
  Events.handleEvent('rider_created', () => {
    getRiders('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('rider_updated', () => {
    getRiders('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('rider_deleted', () => {
    getRiders('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('many_delivery_location_ready_to_be_added', async data => {
    createManyDeliveryLocations(
      data,
      'delivery_location_created',
      'failed_to_create_delivery_location',
    )
  })
  Events.handleEvent('delivery_location_deletion_requested', ({ id }) => {
    deleteDeliveryLocation(
      id,
      'delivery_location_deleted',
      'failed_to_delete_delivery_location',
    )
  })
  Events.handleEvent('delivery_location_ready_to_be_updated', data => {
    updateDeliveryLocation(
      data,
      'delivery_location_updated',
      'failed_to_update_delivery_location',
    )
  })
  Events.handleEvent('delivery_location_created', () => {
    getDeliveryLocations('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('delivery_location_updated', () => {
    getDeliveryLocations('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('delivery_location_deleted', () => {
    getDeliveryLocations('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('new_withdrawal_account_ready_to_be_added', data => {
    createWithdrawalAccount(
      data,
      'withdrawal_account_created',
      'failed_to_create_withdrawal_account',
    )
  })
  Events.handleEvent('withdrawal_account_deletion_requested', ({ id }) => {
    deleteWithdrawalAccount(
      id,
      'withdrawal_account_deleted',
      'failed_to_delete_withdrawal_account',
    )
  })
  Events.handleEvent('withdrawal_account_created', () => {
    getWithdrawalAccounts('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('withdrawal_account_deleted', () => {
    getWithdrawalAccounts('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('withdrawal_requested', data => {
    createWithdrawal(data, 'withdrawal_launched', 'failed_to_launch_withdrawal')
  })
  Events.handleEvent('withdrawal_launched', () => {
    getWithdrawals('many_app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('account_validation_info_available', validationData => {
    saveAccountValidationKycData(
      'account_validation_info_saved',
      'account_validation_info_saving_failed',
      validationData,
    )
  })
  Events.handleEvent('account_validation_info_saved', () => {
    getKycData('app_data_downloaded', 'failed_to_download_app_data')
  })
  Events.handleEvent('match_filters_updated', async filters => {
    const db = await AppDataRepo.getDb()
    const filtersData = Formatter.formatFiltersSelected(filters)
    await db.save(filtersData)
    AppDataController.filterMatches()
  })
  Events.handleEvent('customer_deletion_requested', async ({ customer }) => {
    const prompt = await Events.sendDataRequestResolve(
      'customPrompt',
      {
        title: `Voulez vous vraiment supprimer ${customer.name} ?`,
        subTitle:
          'Si vous supprimez ce client, vous ne pourrez plus le retrouvé',
        successText: 'Supprimer client',
        cancelText: 'Conserver client',
      },
      9999999999,
    )
    if (!prompt.accepted) return null
    deleteCustomer(
      customer.id,
      'customer_deletion_done',
      'customer_deletion_failed',
    )
  })

  Events.handleEvent('customer_deletion_done', () => {
    console.log('customer deleted')
    getCustomers('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('help_message_request_filled', data => {
    console.log('will send help message')
    sendHelpMessage(data, 'help_message_sent', 'help_message_not_sent')
  })

  Events.handleEvent('store_preferences_setted', data => {
    console.log('will save store preferences')
    saveStorePreferences(data, 'store_data_saved', 'failed_to_save_store_data')
  })

  Events.handleEvent('store_data_saved', ({ newData, oldData }) => {
    getStoreData('store_data_downloaded', 'failed_to_download_app_data')
    if (newData.currency !== oldData.currency) {
      updateProductsCurrency(
        {
          oldCurrency: oldData.currency,
          newCurrency: newData.currency,
        },
        'product_updated',
        'failed_to_update_product',
      )
    }
  })

  Events.handleEvent('pro_subscription_payment_required', data => {
    launchSubscriptionPayment(
      data,
      'pro_subscription_payment_launched',
      'failed_to_launch_pro_subscription_payment',
    )
  })

  Events.handleEvent('platform_access_subscription_payment_required', data => {
    launchPlatformAccessSubscriptionPayment(
      data,
      'platform_access_subscription_payment_launched',
      'failed_to_launch_platform_access_subscription_payment',
    )
  })

  Events.handleEvent('order_status_update_available', data => {
    updateOrderStatus(
      data,
      'order_status_updated',
      'failed_to_update_order_status',
    )
  })

  Events.handleEvent('order_status_updated', () => {
    getOrders('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('subscription_payment_done', () => {
    getSubscription('app_data_downloaded', 'failed_to_download_app_data')
  })

  Events.handleEvent('access_subscription_payment_done', () => {
    getPlatformAccessSubscription(
      'app_data_downloaded',
      'failed_to_download_app_data',
    )
  })

  Events.handleEvent('promotion_ready_to_be_launched', data => {
    launchPromotionRequest(
      data,
      'promotion_payment_launched',
      'failed_to_launch_promotion_payment',
    )
  })
}

export { AppDataController }
